var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHandHoldingHeart1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hand-holding-heart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.161,
    height: 20.324,
    viewBox: "0 0 23.161 20.324",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4502",
    "data-name": "Path 4502",
    d: "M142.737,7.449a3.1,3.1,0,0,0,0,4.343l4.085,4.15a1.272,1.272,0,0,0,1.809,0l4.085-4.15a3.1,3.1,0,0,0,0-4.343,3,3,0,0,0-4.278,0l-.712.724-.712-.724a3,3,0,0,0-4.278,0Z",
    transform: "translate(-136.146 -6.55)",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4503",
    "data-name": "Path 4503",
    d: "M22.506,322.9a1.608,1.608,0,0,0-1.906-2.59l-4.813,3.547H10.937a.643.643,0,0,1,0-1.287h3.217a1.287,1.287,0,1,0,0-2.573H7.789a5.16,5.16,0,0,0-3.217,1.126l-1.805,1.448H1.287A1.285,1.285,0,0,0,0,323.86v2.573a1.285,1.285,0,0,0,1.287,1.287H14.174a5.482,5.482,0,0,0,3.245-1.066L22.51,322.9Zm-14.721-.334a.02.02,0,1,1-.011-.022A.02.02,0,0,1,7.785,322.569Z",
    transform: "translate(0 -307.396)",
    fill: "#737373"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHandHoldingHeart1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hand-holding-heart-1.9c852c2fdcedf99e0710958a5270d383.svg";